"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areProductOptionsValidForSku = areProductOptionsValidForSku;
function areProductOptionsValidForSku(optionsForSku, options) {
  return Object.keys(options).every(currOptionKey => {
    const option = optionsForSku.find(o => o.title === currOptionKey);
    if (!option) {
      return false;
    }
    const optionValue = option.values.find(ov => ov.title === options[currOptionKey]);
    if (!optionValue) {
      return false;
    }
    return true;
  });
}